var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9456 8.54602C10.7729 8.71335 10.6936 8.95535 10.7329 9.19268L11.3256 12.4727C11.3756 12.7507 11.2583 13.032 11.0256 13.1927C10.7976 13.3594 10.4943 13.3793 10.2456 13.246L7.29292 11.706C7.19026 11.6513 7.07626 11.622 6.95959 11.6187H6.77892C6.71626 11.628 6.65493 11.648 6.59893 11.6787L3.64559 13.226C3.49959 13.2993 3.33426 13.3253 3.17226 13.2993C2.77759 13.2247 2.51426 12.8487 2.57893 12.452L3.17226 9.17202C3.21159 8.93268 3.13226 8.68935 2.95959 8.51935L0.552258 6.18602C0.350925 5.99068 0.280925 5.69735 0.372925 5.43268C0.462258 5.16868 0.690258 4.97602 0.965592 4.93268L4.27892 4.45202C4.53093 4.42602 4.75226 4.27268 4.86559 4.04602L6.32559 1.05268C6.36026 0.986016 6.40493 0.924682 6.45893 0.872682L6.51892 0.826016C6.55026 0.791349 6.58626 0.762682 6.62626 0.739349L6.69893 0.712682L6.81226 0.666016H7.09293C7.34359 0.692016 7.56426 0.842016 7.67959 1.06602L9.15893 4.04602C9.26559 4.26402 9.47293 4.41535 9.71226 4.45202L13.0256 4.93268C13.3056 4.97268 13.5396 5.16602 13.6323 5.43268C13.7196 5.70002 13.6443 5.99335 13.4389 6.18602L10.9456 8.54602Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.3543081daf0399fca4ec851b5aeb8feb.svg";
export { ForwardRef as ReactComponent };